import React from 'react';

interface IProps {
  width: number;
  height: number;
  fill: string;
  stroke: string;
}

export const Star = ({ width, height, fill, stroke }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M8.76953 1.50781C8.84439 1.32832 9.07647 1.3056 9.19043 1.44043L9.23047 1.50781L10.7178 5.08301C10.954 5.65102 11.4698 6.05066 12.0723 6.1416L12.1943 6.15625L16.0537 6.46484C16.2477 6.4804 16.341 6.69462 16.248 6.84473L16.1963 6.9043L13.2559 9.42383C12.7885 9.82414 12.5681 10.4378 12.668 11.0391L12.6924 11.1592L13.5908 14.9258C13.6356 15.1147 13.4613 15.2691 13.29 15.2275L13.2168 15.1973L9.91211 13.1787C9.38706 12.858 8.73523 12.8375 8.19434 13.1182L8.08789 13.1787L4.7832 15.1973C4.61713 15.2987 4.41632 15.18 4.40332 15.0039L4.40918 14.9258L5.30762 11.1592C5.45037 10.5607 5.26801 9.93454 4.83398 9.50684L4.74414 9.42383L1.80371 6.9043C1.65598 6.77775 1.70586 6.5503 1.86914 6.4834L1.94629 6.46484L5.80566 6.15625C6.41911 6.10707 6.95888 5.73955 7.23145 5.19434L7.28223 5.08301L8.76953 1.50781Z"
      fill={fill}
      stroke={stroke}
      strokeWidth="1.5"
    />
  </svg>
);
